<template>
    <div class="director-interest">
        <index
            v-if="!isDirectorInterestView"
            :payload-for-index="payloadForIndex"
            @add="add"
            @view="view"
            @edit="edit"
            @remove="remove"
        />

        <director-interest-view
            v-if="isDirectorInterestView"
            ref="directorInterestView"
            :data-director-interest="directorInterestView"
            @cancelView ="cancelViewDetails"
            @edit="edit"
            @remove="remove"
        />

        <create-or-edit
            ref="createOrEdit"
            v-model="isDirectorInterestSidebarActive"
            :data-status="status"
            :data-sidebar-action-loading="isSideBarActionLoading"
            :data-director-interest="directorInterest"
            @add-director-interest="create"
            @update-director-interest="update"
        />

        <!-- delete -->
        <confirmation-modal  ref="modal">
            <template slot="body">
                <div>
                    <feather-icon class="d-block mx-auto text-warning" icon="AlertCircleIcon" size="90"/>
                    <h1 class="text-center text-secondary display-5 mt-2">Are you sure?</h1>
                    <p class="text-center mt-2"> You won't be able to revert this! </p>
                </div>
            </template>

            <template slot="footer">
                <b-button class="d-flex" :disabled="isSideBarActionLoading" size="md" variant="primary" @click="confirmDelete">
                    Yes, delete it!
                    <normal-loader v-if="isSideBarActionLoading" class="left-10%" />
                </b-button>

                <b-button size="md" variant="outline-danger" @click="cancelDelete">
                    Cancel
                </b-button>
            </template>
        </confirmation-modal>
    </div>
</template>

<script>
import {
    BButton,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import { ref } from '@vue/composition-api';
import { errorToast, successToast } from "@/views/helpers/toast";
import ConfirmationModal from '@/views/components/utils/ConfirmationModal.vue';
import { DIRECTOR_INTEREST_CREATE_SUCCESS, DIRECTOR_INTEREST_DELETE_SUCCESS, DIRECTOR_INTEREST_UPDATE_SUCCESS, SAME_DIRECTOR_INTEREST_CREATE_SUCCESS } from '@/constants/success';
import DirectorInterest from '@/models/DirectorInterest';
import { REFRESH_AND_TRY_AGAIN_ERROR, SOMETHING_WENT_WRONG } from '@/constants/errors';
import { SERVER_VALIDATION_STATUS_CODE } from '@/constants/http-status-code';
import { COMPANY } from '@/constants/config';
import { isPast } from '@/helpers';
import useDirectorInterestsTable from './useDirectorInterestsTable';
import CreateOrEdit from './CreateOrEdit.vue';
import DirectorInterestView from './view/View.vue';
import Index from './Index.vue';

export default {
    components: {
        Index,
        BButton,
        DirectorInterestView,
        CreateOrEdit,
        ConfirmationModal,
    },

    data() {
        return {
            status: undefined,
            directorInterest: {
                // nameOfCompany: this.$store.getters['company/fullCompanyName']
            },
            directorInterestView: null,
            isDirectorInterestSidebarActive: false,
            isSideBarActionLoading: false,
            isDirectorInterestView: false,
        };
    },

    computed: {
        ...mapGetters({
            isUserAdmin: "auth/isAdmin",
        }),
    },

    watch: {
        '$route.query': {
            handler (query) {
                if(! query.status) {
                    this.isDirectorInterestView = false;
                }
            },
        },
    },

    mounted()
    {
        // just to make sure the menu bar is shown
        this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);

        if(this.$route.query.status)
            this.$router.push({ name: 'director-interests', query: {}});
    },

    methods:{
        add(){
            // this.directorInterest = {
            //     nameOfCompany: this.$store.getters['company/fullCompanyName']
            // };
            this.status = "create";
            this.directorInterest = {};
            this.isDirectorInterestSidebarActive = true;
        },

        async view(data){
            this.directorInterestView = data.item;
            this.status = "view";
            this.isDirectorInterestView = true;
            this.$router.push({path: 'director-interests', query: { status: this.status }});
        },

        edit(data){
            this.directorInterest = data.item;
            this.status = "edit";
            this.isDirectorInterestSidebarActive = true;
        },

        cancelViewDetails(){
            this.directorInterests = [];
            this.directorInterest = {};
            this.isDirectorInterestView = false;
            this.fetchDirectorInterests();
            this.$router.push({path: 'director-interests'});
        }
    },

    setup() {
        const filterMode = ref(false);
        const dataToDelete = ref(undefined);
        const directorInterestView = ref(null);

        const {
            // table data
            sortBy,
            perPage,
            isBusy,
            dataMeta,
            currentPage,
            searchQuery,
            tableColumns,
            isSortDirDesc,
            perPageOptions,

            // UI
            resolveDirectorInterestStatusVariant,
            isLoading,

            directorInterests,
            refetchData,
            fetchDirectorInterests,
            refDirectorInterestListTable,
            totalDirectorInterests,
        } = useDirectorInterestsTable();

        const payloadForIndex = {
            refetchData,
            sortBy,
            perPage,
            isBusy,
            dataMeta,
            currentPage,
            searchQuery,
            tableColumns,
            isSortDirDesc,
            isLoading,
            perPageOptions,
            directorInterests,
            fetchDirectorInterests,
            totalDirectorInterests,
            refDirectorInterestListTable,
            resolveDirectorInterestStatusVariant,
        };

        function create(directorInterest){
            // eslint-disable-next-line no-param-reassign
            if (this.isUserAdmin)
            {
                this.isSideBarActionLoading = true;

                DirectorInterest.create(directorInterest)
                    .then(() => {
                        this.isDirectorInterestSidebarActive = false;
                        this.isSideBarActionLoading = false;

                        const isExistingUser = refDirectorInterestListTable.value.localItems.filter(item => item.director.userId === directorInterest.director.userId);
                        if (! isExistingUser.length > 0)
                        {
                            const {cessation} = directorInterest.director;

                            // eslint-disable-next-line no-param-reassign
                            directorInterest.status = (cessation && isPast(cessation)) ? COMPANY.DIRECTOR.STATUS_RESIGNED : COMPANY.DIRECTOR.STATUS_ACTIVE;

                            refDirectorInterestListTable.value.localItems.push(directorInterest);
                            successToast(DIRECTOR_INTEREST_CREATE_SUCCESS);
                            return;
                        }
                        successToast(SAME_DIRECTOR_INTEREST_CREATE_SUCCESS);
                    })
                    .catch(e => {
                        this.isSideBarActionLoading = false;
                        // backend(laravel) server validation error status code
                        if (e.response.status === SERVER_VALIDATION_STATUS_CODE) {
                            errorToast(e.response.data.error?.global.join(", "));
                            return;
                        }

                        errorToast(SOMETHING_WENT_WRONG);
                        console.error(
                            "error while trying to create director interest",
                            e
                        );
                    });
            }
        };

        function update(data) {
            if (this.isUserAdmin)
            {
                this.isSideBarActionLoading = true;

                if (! data.userId)
                {
                    errorToast(REFRESH_AND_TRY_AGAIN_ERROR);
                    return;
                }

                DirectorInterest.update(data.id, data).then(() => {
                    this.isDirectorInterestSidebarActive = false;
                    this.isSideBarActionLoading = false;

                    directorInterestView.value.directorInterestViewList = [];
                    directorInterestView.value.fetchDirectorInterests(this.directorInterestView.director.userId);

                    this.directorInterest={};
                    successToast(DIRECTOR_INTEREST_UPDATE_SUCCESS);
                })
                    .catch(e => {
                        this.isSideBarActionLoading = false;
                        if (e.response.status === SERVER_VALIDATION_STATUS_CODE) {
                            errorToast(e.response.data.error?.global.join(", "));
                            return;
                        }

                        errorToast(SOMETHING_WENT_WRONG);
                        console.error(
                            "error while trying to update director interest",
                            e
                        );
                    });
            }
        };

        function remove(data) {
            this.$refs.modal.$refs.confirmationModal.show();
            dataToDelete.value= data;
        };

        function cancelDelete() {
            dataToDelete.value = null;
            this.$refs.modal.$refs.confirmationModal.hide();
        }

        function confirmDelete() {
            if (this.isUserAdmin) {
                this.isSideBarActionLoading = true;

                if (! dataToDelete.value.item.id)
                {
                    errorToast(REFRESH_AND_TRY_AGAIN_ERROR);
                    return;
                }

                DirectorInterest.delete(dataToDelete.value.item.id).then(() => {
                    this.isSideBarActionLoading = false;

                    directorInterestView.value.directorInterestViewList = [];
                    directorInterestView.value.fetchDirectorInterests(dataToDelete.value.item.director.userId);

                    this.$refs.modal.$refs.confirmationModal.hide();

                    dataToDelete.value = null;

                    // if (directorInterestView.value.directorInterestViewList.length >= 0)
                    // {
                    //     this.isDirectorInterestView = false;
                    //     this.$router.push({path: 'director-interests'});
                    // }

                    fetchDirectorInterests();
                    successToast(DIRECTOR_INTEREST_DELETE_SUCCESS);
                })
                    .catch(e => {
                        this.isSideBarActionLoading = false;
                        errorToast(SOMETHING_WENT_WRONG);
                        console.error(
                            "error while trying to delete director interest",
                            e
                        );
                    });
            }
        };

        return {
            refDirectorInterestListTable,
            refetchData,
            directorInterests,
            // eslint-disable-next-line vue/no-dupe-keys
            directorInterestView,

            // UI
            filterMode,

            // methods
            create,
            update,
            remove,
            confirmDelete,
            cancelDelete,
            fetchDirectorInterests,
            payloadForIndex,
        };
    }
};
</script>